<div class="menu">
  <ul class="list-group">
    @for (item of items; track item; let i = $index) {
      @if (!item.items) {
        <li
          class="list-group-item d-flex align-items-center menu-item"
          [class.active]="itemRla.isActive">
          @if (item.icon) {
            <ng-icon
              [name]="item.icon"
              class="me-2 app-icon app-icon--md app-icon-inline" />
          }
          <a
            class="text-decoration-none flex-grow-1"
            [routerLink]="item.routerLink"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.exact === true }"
            #itemRla="routerLinkActive">
            {{ item.labelKey | translate }}
          </a>
        </li>
      }
      @if (item.items) {
        <li
          class="list-group-item menu-item"
          routerLinkActive="active"
          #parentRla="routerLinkActive">
          <button
            class="btn w-100 d-flex justify-content-between align-items-center menu-btn"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#submenu-' + i"
            [attr.aria-expanded]="parentRla.isActive">
            <span>
              @if (item.icon) {
                <ng-icon
                  [name]="item.icon"
                  class="me-2 app-icon app-icon--md app-icon-inline" />
              }
              {{ item.labelKey | translate }}
            </span>
            <ng-icon
              name="bootstrapChevronDown"
              class="small app-icon app-icon--md app-icon-inline" />
          </button>
          <ul
            class="list-group collapse ms-3 mt-2"
            [id]="'submenu-' + i"
            [class.show]="parentRla.isActive">
            @for (sub of item.items; track sub) {
              <li
                class="list-group-item list-group-item-action submenu-item"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                @if (sub.icon) {
                  <ng-icon
                    [name]="sub.icon"
                    class="me-2 app-icon app-icon--md app-icon-inline" />
                }
                <a class="text-decoration-none" [routerLink]="sub.routerLink">
                  {{ sub.labelKey | translate }}
                </a>
              </li>
            }
          </ul>
        </li>
      }
    }
  </ul>
</div>
